module.exports = __webpack_public_path__ + "static/media/button-tick-request.a67ed16a.svg";